import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api';

export function useTemplates() {
  return useQuery({
    queryKey: ['templates'],
    queryFn: () => apiClient.get('/templates'),
    staleTime: 5 * 60 * 1000, // Templates rarely change, cache for 5 mins
  });
}

export function useTemplate(id: string) {
  return useQuery({
    queryKey: ['template', id],
    queryFn: () => apiClient.get(`/templates/${id}`),
    enabled: !!id,
  });
}
